import TableDataMobile from "./TableDataMobile";

export default TableDataMobile;
